// extracted by mini-css-extract-plugin
export default {"control":"Product_control__evpu1","richText":"Product_richText__0Qg4u"};